import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";

// Bandeau neutre (aucune donnée financière) quand l'abonnement de l'entreprise est suspendu ou en attente.
export function OrgStatusBanner() {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/billing/org-status").then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st) return null;
  const isAdmin = user?.role === "admin";
  if (st.read_only) {
    return (
      <div data-testid="readonly-banner" className="bg-red-50 border-b border-red-200 text-red-800 text-sm font-semibold px-4 py-2.5 flex items-center gap-2">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <span>L'abonnement SanitDocs de votre entreprise nécessite une régularisation. {isAdmin ? <Link to="/app/abonnement" className="underline">Régulariser</Link> : "Contactez votre administrateur."}</span>
      </div>
    );
  }
  if (isAdmin && st.subscription_status === "payment_pending") {
    return (
      <div data-testid="payment-pending-banner" className="bg-orange-50 border-b border-orange-200 text-orange-800 text-sm font-semibold px-4 py-2.5 flex items-center gap-2">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <span>Un paiement SanitDocs n'a pas abouti. <Link to="/app/abonnement" className="underline">Voir Abonnement & facturation</Link></span>
      </div>
    );
  }
  return null;
}
